var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFirePerimeter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  "data-name": "Fire Perimeter"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 320"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#955249",
  d: "M27.856 41.401 3.114 31.826.592 11.4l20.673 6.586.362.115.208-.318 10.928-16.68 8.67 23.435Z",
  "data-name": "Path 1121"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "m32.638 2.206-10.8 16.487-20.654-6.578 2.389 19.352 24.119 9.336 13.174-16.357zM32.888 0 42 24.631 28.013 42 2.656 32.184l-2.654-21.5 21.415 6.831Z",
  "data-name": "Path 1122"
}))));
export default SvgFirePerimeter;